<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="140px">
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="封面图：" prop="cover_img" class="cover_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <img v-if="model.cover_img" :src="model.cover_img" class="upImg" style="width: 200px;height: 160px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 200px;height: 160px;line-height: 160px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 400px</span>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
                <el-date-picker v-model="model.start_time" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 200px"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <el-date-picker v-model="model.end_time" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 200px"></el-date-picker>
            </el-form-item>
            <el-form-item label="奖品一名称：" prop="goods_name1">
                <el-input v-model="model.goods_name1"></el-input>
            </el-form-item>
            <el-form-item label="奖品一图片：" prop="goods_img1" class="share_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess1"
                    :before-upload="beforeUpload">
                    <img v-if="model.goods_img1" :src="model.goods_img1" class="upImg" style="width: 200px;height: 200px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 200px;height: 200px;line-height: 200px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 500px</span>
            </el-form-item>
            <el-form-item label="奖品一链接：" prop="goods_link1">
                <el-input v-model="model.goods_link1"></el-input>
            </el-form-item>
            <el-form-item label="奖品二名称：" prop="goods_name2">
                <el-input v-model="model.goods_name2"></el-input>
            </el-form-item>
            <el-form-item label="奖品二图片：" prop="goods_img2" class="share_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess2"
                    :before-upload="beforeUpload">
                    <img v-if="model.goods_img2" :src="model.goods_img2" class="upImg" style="width: 200px;height: 200px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 200px;height: 200px;line-height: 200px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 500px</span>
            </el-form-item>
            <el-form-item label="奖品二链接：" prop="goods_link2">
                <el-input v-model="model.goods_link2"></el-input>
            </el-form-item>
            <el-form-item label="奖品二邀请人数：" prop="invite_count2">
                <el-input v-model.number="model.invite_count2"></el-input>
            </el-form-item>
            <el-form-item label="奖品三名称：" prop="goods_name3">
                <el-input v-model="model.goods_name3"></el-input>
            </el-form-item>
            <el-form-item label="奖品三图片：" prop="goods_img3" class="share_img">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess3"
                    :before-upload="beforeUpload">
                    <img v-if="model.goods_img3" :src="model.goods_img3" class="upImg" style="width: 200px;height: 200px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 200px;height: 200px;line-height: 200px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 500px</span>
            </el-form-item>
            <el-form-item label="奖品三链接：" prop="goods_link3">
                <el-input v-model="model.goods_link3"></el-input>
            </el-form-item>
            <el-form-item label="奖品三邀请人数：" prop="invite_count3">
                <el-input v-model.number="model.invite_count3"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import config from '@/config'

export default {
    name: 'raffleEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                title: '',
                cover_img: '',
                start_time: '',
                end_time: '',
                state: '',
                goods_name1: '',
                goods_img1: '',
                goods_link1: '',
                goods_name2: '',
                goods_img2: '',
                goods_link2: '',
                invite_count2: '',
                goods_name3: '',
                goods_img3: '',
                goods_link3: '',
                invite_count3: '',
                winning_member_ids: '',
                addtime: '',
                creator: '',
            },
            getObj:{
                url:'/api/admin/raffle/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'}
                ],
                cover_img: [
                    {required: true, message: '封面图不能为空', trigger: 'blur'}
                ],
                start_time: [
                    {required: true, message: '开始时间不能为空', trigger: 'blur'}
                ],
                end_time: [
                    {required: true, message: '结束时间不能为空', trigger: 'blur'}
                ],
                goods_name1: [
                    {required: true, message: '奖品一名称不能为空', trigger: 'blur'}
                ],
                goods_img1: [
                    {required: true, message: '奖品一图片不能为空', trigger: 'blur'}
                ],
                goods_name2: [
                    {required: true, message: '奖品二名称不能为空', trigger: 'blur'}
                ],
                goods_img2: [
                    {required: true, message: '奖品二图片不能为空', trigger: 'blur'}
                ],
                goods_name3: [
                    {required: true, message: '奖品三名称不能为空', trigger: 'blur'}
                ],
                goods_img3: [
                    {required: true, message: '奖品三图片不能为空', trigger: 'blur'}
                ],
                invite_count2: [
                    {required: true, message: '奖品二邀请人数不能为空', trigger: 'blur'},
                    {type: 'number', message: '奖品二邀请人数必须是数字值', trigger: 'blur'}
                ],
                invite_count3: [
                    {required: true, message: '奖品三邀请人数不能为空', trigger: 'blur'},
                    {type: 'number', message: '奖品三邀请人数必须是数字值', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "raffle",
            },
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/raffle/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.cover_img = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess1(res, file){
            if(res.code ==1){
                this.model.goods_img1 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess2(res, file){
            if(res.code ==1){
                this.model.goods_img2 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess3(res, file){
            if(res.code ==1){
                this.model.goods_img3 = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
    }
};
</script>